import { index, pgEnum, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';

import { interviewSessions } from './interview-sessions';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const interviewFeedbackThumbsEnum = pgEnum('interview_feedback_thumbs', ['up', 'down']);

export type InterviewFeedbackThumbs = (typeof interviewFeedbackThumbsEnum.enumValues)[number];

export const interviewFeedback = pgTable(
  'interview_feedback',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    sessionId: uuid('session_id')
      .notNull()
      .references(() => interviewSessions.id),
    thumbs: interviewFeedbackThumbsEnum('thumbs').notNull(),
    notes: text('notes'),
    createdAt: timestamp('created_at').notNull().defaultNow()
  },
  (t) => [index('interview_feedback_session_id_idx').on(t.sessionId), tenantOrgIsolationPolicy()]
).enableRLS();
